import type { RequestRepository } from '@zetyar/data-contracts'
import { createSupabaseRequestRepository } from '@zetyar/supabase-client'
import { getSupabaseClient } from '@/infrastructure/supabase/app'

export const webRequestRepository: RequestRepository = createSupabaseRequestRepository(getSupabaseClient())
